import React, { useState } from "react";

const BookingFilters = ({
  filters,
  setFilters,
  toggleRoomType,
  resetFilters,
  mobileFilterOpen,
  setMobileFilterOpen,

  // Data coming from your API
  roomCategories = [],
}) => {
  const [reviewScore, setReviewScore] = useState(
    filters.reviewScore || 8
  );

  const [starRating, setStarRating] = useState(
    filters.starRating || 3
  );

  const [showMore, setShowMore] = useState(false);

  const updateReviewScore = (value) => {
    const score = Number(value);

    setReviewScore(score);

    setFilters((previous) => ({
      ...previous,
      reviewScore: score,
    }));
  };

  const updateStarRating = (value) => {
    const rating = Number(value);

    setStarRating(rating);

    setFilters((previous) => ({
      ...previous,
      starRating: rating,
    }));
  };

  const handleReset = () => {
    setReviewScore(8);
    setStarRating(3);
    setShowMore(false);

    resetFilters();
  };

  /*
   * =========================================================
   * ROOM CATEGORY SELECTION
   * =========================================================
   */

  const isCategorySelected = (category) => {
    if (!filters.roomTypes) {
      return false;
    }

    return filters.roomTypes.includes(
      category.name
    );
  };

  const handleCategoryClick = (category) => {
    toggleRoomType(category.name);
  };

  return (
    <aside
      className={`be-filter-sidebar ${
        mobileFilterOpen
          ? "mobile-open"
          : ""
      }`}
    >

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="be-filter-header">

        <strong className="be-filter-main-title">
          Filter by:
        </strong>

        <button
          type="button"
          className="be-reset-btn"
          onClick={handleReset}
        >
          Reset
        </button>

      </div>


      {/* =====================================================
          BUDGET
      ===================================================== */}

      <div className="be-filter-section">

        <h4>
          Budget per night:
        </h4>

        <div className="be-budget-values">

          <span>
            ₹{" "}
            {Number(
              filters.minPrice || 100
            ).toLocaleString("en-IN")}
          </span>

          <span>
            ₹{" "}
            {Number(
              filters.maxPrice || 20000
            ).toLocaleString("en-IN")}
          </span>

        </div>

        <div className="be-dual-range">

          <div className="be-range-track" />

          <div
            className="be-range-active"
            style={{
              left: "12%",
              right: "28%",
            }}
          />

          <span
            className="be-range-handle"
            style={{
              left: "12%",
            }}
          />

          <span
            className="be-range-handle"
            style={{
              left: "72%",
            }}
          />

          <input
            type="range"
            min="100"
            max="20000"
            step="100"
            value={
              filters.minPrice || 100
            }
            onChange={(e) => {

              const value =
                Number(e.target.value);

              setFilters((previous) => ({
                ...previous,

                minPrice: Math.min(
                  value,
                  previous.maxPrice ||
                    20000
                ),
              }));

            }}
            className="be-range-input be-range-min"
          />

          <input
            type="range"
            min="100"
            max="20000"
            step="100"
            value={
              filters.maxPrice || 20000
            }
            onChange={(e) => {

              const value =
                Number(e.target.value);

              setFilters((previous) => ({
                ...previous,

                maxPrice: Math.max(
                  value,
                  previous.minPrice ||
                    100
                ),
              }));

            }}
            className="be-range-input be-range-max"
          />

        </div>

      </div>


      {/* =====================================================
          FREQUENTLY USED
      ===================================================== */}

      <div className="be-filter-section">

        <h4>
          Frequently use:
        </h4>

        <div className="be-filter-pills">

          {roomCategories.length > 0 ? (

            roomCategories.map((category) => {

              const selected =
                isCategorySelected(
                  category
                );

              return (
                <button
                  key={
                    category.id ||
                    category.name
                  }
                  type="button"
                  className={
                    selected
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    handleCategoryClick(
                      category
                    )
                  }
                >

                  <span>
                    {category.name}
                  </span>

                  <span className="be-category-count">
                    (
                    {
                      category.availableRooms ??
                      category.roomCount ??
                      category.count ??
                      0
                    }
                    )
                  </span>

                </button>
              );

            })

          ) : (

            <span className="be-filter-empty">
              No room categories available
            </span>

          )}

        </div>

      </div>


      {/* =====================================================
          REVIEW SCORE
      ===================================================== */}

      <div className="be-filter-section">

        <div className="be-filter-title-row">

          <h4>
            Review score:
          </h4>

          <strong className="be-blue-value">
            +{reviewScore}
          </strong>

        </div>

        <div className="be-review-range">

          <input
            type="range"
            min="5"
            max="10"
            step="1"
            value={reviewScore}
            onChange={(e) =>
              updateReviewScore(
                e.target.value
              )
            }
          />

        </div>

        <div className="be-range-labels">

          <span>
            5.0
          </span>

          <span>
            10
          </span>

        </div>

      </div>


      {/* =====================================================
          STAR RATING
      ===================================================== */}

      <div className="be-filter-section">

        <h4>
          Star rating:
        </h4>

        <div className="be-star-range">

          <input
            type="range"
            min="1"
            max="5"
            step="1"
            value={starRating}
            onChange={(e) =>
              updateStarRating(
                e.target.value
              )
            }
          />

        </div>

        <div className="be-star-labels">

          <span>+1</span>
          <span>+2</span>
          <span>+3</span>
          <span>+4</span>
          <span>+5</span>

        </div>

      </div>


      {/* =====================================================
          MORE OPTIONS
      ===================================================== */}

      {showMore && (

        <div className="be-filter-section">

          <h4>
            Room type:
          </h4>

          {roomCategories.map(
            (category) => (

              <label
                className="be-checkbox"
                key={
                  category.id ||
                  category.name
                }
              >

                <input
                  type="checkbox"
                  checked={
                    isCategorySelected(
                      category
                    )
                  }
                  onChange={() =>
                    handleCategoryClick(
                      category
                    )
                  }
                />

                <span>
                  {category.name}
                </span>

              </label>

            )
          )}

        </div>

      )}


      {/* =====================================================
          SEE MORE
      ===================================================== */}

      <button
        type="button"
        className="be-see-more"
        onClick={() =>
          setShowMore(!showMore)
        }
      >

        <span>
          {showMore
            ? "Show fewer options"
            : "See more options"}
        </span>

        <span className="be-see-more-arrow">
          →
        </span>

      </button>


      {/* =====================================================
          MOBILE
      ===================================================== */}

      <button
        type="button"
        className="be-mobile-filter-close"
        onClick={() =>
          setMobileFilterOpen(false)
        }
      >
        Apply Filters
      </button>

    </aside>
  );
};

export default BookingFilters;